import layoutList from '@/layouts/layout-list.vue'

export default [
  {
    path: '',
    redirect: '',
    component: layoutList,
    /* hidden: true, */
    children: [{
      path: '/personCenter/:id',
      name: 'personCenter',
      component: resolve => require.ensure([], () => resolve(require('@/views/personCenter/index.vue')), 'personCenter'),
      meta: { title: '个人中心', icon: '' }
    }]
  }
]
